import env from '@repo/env';

export const USER_API_URL = env.apiUrl;
